export var PaymentReminderTarget = /*#__PURE__*/function (PaymentReminderTarget) {
  PaymentReminderTarget["company"] = "company";
  PaymentReminderTarget["user"] = "user";
  return PaymentReminderTarget;
}(PaymentReminderTarget || {});
export const PaymentReminderTargetOptions = [{
  value: PaymentReminderTarget.company,
  label: 'Unternehmen'
}, {
  value: PaymentReminderTarget.user,
  label: 'User'
}];